<template>
<div class="bannerbox">
    <!-- <div class="tui-searchbox">
        <div class="tui-search-input" bindtap="search">
            <van-icon name="search" size="15" color="#999" />
            <input class="tui-search-text" placeholder="请输入关键字">
        </div>
    </div> -->
    <div class="banner-menu">
        <div @click="golist()" class="menu-item">
            <span>全部</span>
        </div>
        <div class="menu-item" :class="index == menuIndex ? 'menu-item-selected' : ''" v-for="(item, index) in menuList" :key="index" @click="showMenu(index)">

            <span>{{ item.name }}</span>
            <!-- <img src="@/assets/images/icon_right.png" /> -->
        </div>
        <div class="menu-children">
            <div class="children-item" @click="goLists(children.name)" v-for="(children, index) in childrenList" :key="index">
                <div><img width="80%" :src="children.pictureUrl" alt=""></div>

                <div>{{ children.name }}</div>
            </div>
        </div>
    </div>
    <!-- <van-tree-select height="100%" :items="items" :main-active-index.sync="active">
        <template #content>
            <div class="tab_con">
                <div v-for="(item, index) in children" :key="index" class="classification">
                    <div>
              <img class="cationimg" :src="item.src" alt="" />
            </div>
                    <div class="cationtitle">{{ item.title }}</div>
                </div>
            </div>
        </template>
    </van-tree-select> -->
</div>
</template>

<script>
import {
    queryBeforeCategory
} from "@/api/api";
export default {
    components: {},
    props: {},
    data() {
        return {
            menuList: [],
            menuIndex: null,
            active: 0,
            activeId: 1,
            activeIndex: 0,
            childrenList: [],
        };
    },
    watch: {},
    computed: {},
    methods: {
        showMenu(index) {
            this.menuIndex = index;
            const childrenList = this.menuList[index].categoryList;
            this.childrenList = childrenList;
        },
        async queryBeforeCategory() {
            let params = {
                id: "1",
                isVisible: 1,
            };
            let res = await queryBeforeCategory(params);
            if (res.code == "0000") {
                this.menuList = res.data[0].categoryList;
                this.childrenList = res.data[0].categoryList[0].categoryList;
                this.menuIndex = 0;
            }
        },
        goLists(name) {
            this.$router.push({
                path: "/productList",
                query: {
                    categoryName: name,
                },
            });
        },
        golist() {
            this.$router.push({
                path: "/productlist",
                query: {
                    status: 1,
                }

            });
        },
    },
    created() {},
    mounted() {
        this.queryBeforeCategory();
    },
};
</script>

<style lang="scss" scoped>
.bannerbox{
    background: #fff;
}
.banner-top {
    height: 485px;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.banner-menu {
    padding: 50px 0;
    width: 200px;
    // height: 850px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    position: relative;
}

.menu-item {
    flex: 1;
    padding: 30px 30px;
    color: #000;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    img {
        height: 12px;
        width: 12px;
    }

    span {
        width: 130px;
        font-size: 28px;
    }
}

.menu-item-selected {
    background-color: #046cd0;
    color: #fff;
}

.menu-children {
    position: absolute;
    width: 550px;
    // height: 850px;
    background-color: rgba($color: #fff, $alpha: 0.8);
    top: 0;
    right: -550px;
    z-index: 10;
    padding: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
}

.children-item {
    width: 50%;
    color: #000;
    font-size: 28px;
    // cursor: pointer;
    // margin-right: 40px;
    margin-bottom: 40px;
    font-weight: bold;
    text-align: center;
    padding: 20px 0;
}

.children-item:hover {
    color: #2283e2;
}

.banner-slider {
    height: 100%;
    width: 1010px;
}

.tab_con {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin-top: 50px;
}

.classification {
    width: 250px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    box-sizing: border-box;
    align-items: center;
    margin-bottom: 50px;
}

.cationtitle {
    padding-top: 10px;
    font-size: 27px;
    color: #111;
}

.cationimg {
    width: 160px;
    height: 160px;
    border-radius: 160px;
}

.tui-searchbox {
    width: 100%;
    height: 92px;
    padding: 0 30px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    left: 0;
    top: 0;
    z-index: 100;
}

.tui-searchbox::after {
    content: "";
    position: absolute;
    border-bottom: 1px solid #d2d2d2;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    bottom: 0;
    right: 0;
    left: 0;
}

.tui-search-input {
    width: 100%;
    height: 68px;
    border: 2px solid #cbcbcb;
    border-radius: 34px;
    font-size: 26px;
    color: #999;
    display: flex;
    align-items: center;
    padding-left: 32px;

    input {
        border: none;
    }
}

.tui-search-text {
    padding-left: 16px;
}
</style>
